import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { ButtonMain } from '../atoms';
import { useDeleteProjectDocumentsMutation, useGetProjectDocumentsQuery } from '../redux/rtkQuery/apiSlice';
import { CustomParams } from '../modules/clientModule/types';
import { RootState } from '../redux/root';
import { ModalDeleteConfirmation } from '../molecules';

const NEW = 64;
const NOT_APPLICABLE = 48;
const SubPermitMenuDocDeleteButton = () => {
  const [params, setParams] = useState<any>();
  const [show, setShow] = useState<boolean>();
  const { pageIndex, pageSize } = useSelector((s: RootState) => s.pagination);
  const mcheckedBoxes = useSelector((s: RootState) => s.documents.mcheckedBoxes);
  const { data: documents } = useGetProjectDocumentsQuery(params, { skip: params === undefined });
  const [deleteProjectDocuments] = useDeleteProjectDocumentsMutation();
  // @ts-ignore
  const { permitId } = useParams();
  const _params: CustomParams = {
    is_deleted: false,
    limit: pageSize,
    offset: pageIndex * pageSize,
    permit_id: permitId,
    event_type: 'Activity',
    activity_type_name: 'Document',
  };

  useEffect(() => {
    if (permitId) {
      setParams(_params);
    }
  }, [permitId]);
  const onConfirm = async () => {
    const deleteCandidates = documents.results.reduce((candidArr, doc) => {
      if (doc.status === NEW || doc.status === NOT_APPLICABLE) {
        candidArr.push(doc);
      }
      return candidArr;
    }, []);
    const ids = Object.keys(mcheckedBoxes)
      .reduce((docArr, key) => {
        const isChecked = mcheckedBoxes[key];
        const candidate = deleteCandidates.find(doc => doc.pk === Number(key) && isChecked);
        if (candidate) {
          docArr.push(candidate.pk);
        }
        return docArr;
      }, []);

    await deleteProjectDocuments({
        document_ids: ids,
    });
    setShow(false);
  };
  const isDisabled = () => {
    let isAnyChecked = false;
    Object.keys(mcheckedBoxes).forEach(key => {
      if (!isAnyChecked) {
        isAnyChecked = mcheckedBoxes[key];
      }
    });
    return !isAnyChecked;
  };
  return (
    <>
      {show && (
        <ModalDeleteConfirmation onConfirm={onConfirm} onCancel={() => setShow(false)}>
          Confirm delete action for a Document's file
        </ModalDeleteConfirmation>
      )}
      <ButtonMain onClick={() => setShow(true)} disabled={isDisabled()}>
        Delete
      </ButtonMain>
    </>
  );
};

export default SubPermitMenuDocDeleteButton;
